import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling, withRouterConfig, withPreloading } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { PreloadAllModules } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from "ngx-toastr";
import { cacheInterceptor } from "./shared/interceptors/cache.interceptor";
import { authInterceptor } from "./shared/interceptors/auth.interceptor";
import { errorInterceptor } from "./shared/interceptors/error.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      }),
      withRouterConfig({
        paramsInheritanceStrategy: 'emptyOnly'
      }),
      withPreloading(PreloadAllModules)
    ),
    // Modern functional interceptors (Angular 18+)
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        errorInterceptor,
        cacheInterceptor
      ])
    ),
    provideAnimationsAsync(),
    provideToastr({
      timeOut: 8000,
      positionClass: 'toast-top-right',
      closeButton: true,
      preventDuplicates: true,
      toastClass: 'ngx-toastr toast-outlined',
      easeTime: 300,
    })
  ]
};
